package com.loyola.acessoescola.ui.adminpanel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.loyola.acessoescola.data.AcessoEscolaRecordFields
import com.loyola.acessoescola.services.QuickAuthClient
import com.loyola.acessoescola.services.adminpanel.AdminPanelApi
import com.loyola.acessoescola.services.adminpanel.EventType
import com.loyola.acessoescola.services.adminpanel.LogEntry
import com.loyola.acessoescola.services.quintadb.AcessoEscolaAPI
import com.loyola.acessoescola.services.quintadb.EndPoints
import com.loyola.acessoescola.services.quintadb.ExpiredTokenException
import kotlinx.browser.document
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLAnchorElement

actual class AdminPanelViewModel actual constructor(
    private val adminPanelApi: AdminPanelApi,
    private val quickAuthClient: QuickAuthClient,
    private val acessoEscolaAPI: AcessoEscolaAPI
) : ViewModel() {

    private val _logs = MutableStateFlow<List<LogEntry>>(listOf())
    val logs: StateFlow<List<LogEntry>> get() = _logs

    private val _uiState = MutableStateFlow(AdminPanelState())

    val uiState: StateFlow<AdminPanelState> = _uiState.asStateFlow()

    private fun onLogsLoadingChange(state: Boolean) {
        _uiState.update { it.copy(isLogsLoading = state) }
    }

    fun onErrorMessageChange(message: String){
        _uiState.update { it.copy(errorMessage = message) }
    }

    fun setAsUpdated(
        logEntry: LogEntry,
        onErrorCallback: (String?) -> Unit
    ) {
        quickAuthClient.getCurrentAccount(
            onErrorCallBack = { onErrorCallback(it) },
        ) { _, userIDToken ->
            viewModelScope.launch {
                try {
                    adminPanelApi.setAsUpdated(
                        userIDToken = userIDToken ?: "",
                        logEntry = logEntry,
                    ).collect {
                        resetState()
                        _uiState.update { it.copy(activeLogEntry = null) }
                        updateLogList(onErrorCallback)
                    }
                } catch (e: Exception) {
                    onErrorCallback(e.message)
                }
            }
        }
    }

    fun resetState() {
        _uiState.update {
            it.copy(
                fullName = "",
                cpf = "",
                bound = "",
                phone = "",
                photoUrl = "",
                activeLogEntry = null
            )
        }
    }

    fun onActiveLogEntryChange(
        logEntryID: Int,
        recordID: String,
        eventType: String,
        onErrorCallback: (String?) -> Unit
    ) {
        _uiState.update { it.copy(activeLogEntry = logEntryID) }

        if (eventType == EventType.DELETE.value) {
            return //Não faz nada
        }

        quickAuthClient.getCurrentAccount(
            onErrorCallBack = { onErrorCallback(it) },
        ) { _, userIDToken ->
            viewModelScope.launch {

                try {
                    acessoEscolaAPI.getRecord(
                        userIDToken = userIDToken ?: "",
                        recordID = recordID
                    ).collect { record ->
                        _uiState.update {
                            it.copy(
                                fullName = record.jsonValues.name,
                                cpf = record.jsonValues.cpf,
                                bound = record.jsonValues.bound,
                                phone = record.jsonValues.phone,
                                photoUrl = "${EndPoints.PROXY_IMAGE.endPoint}?url=https://quintadb.com/images/data4/${AcessoEscolaRecordFields.PHOTO.fieldName}/${recordID}/${record.jsonValues.photo}"
                            )
                        }
                    }
                } catch (e: Exception) {
                    onErrorCallback(e.message)
                }
            }
        }
    }

    fun downloadPhoto(photoUrl: String) {
        val link = document.createElement("a") as HTMLAnchorElement
        link.href = photoUrl
        link.download = "Facial.png"
        document.body?.append(link)
        link.click()
        link.remove()
    }

    fun updateLogList(onErrorCallback: (String?) -> Unit) {
        onLogsLoadingChange(true)
        quickAuthClient.getCurrentAccount(
            onErrorCallBack = {
                onLogsLoadingChange(false)
                onErrorCallback(it)
            },
        ) { _, userIDToken ->
            viewModelScope.launch {

                try {
                    adminPanelApi.getLogs(userIDToken ?: "").collect { logList ->
                        _logs.update { logList.filter { !it.FreeAccessUpdated } }
                    }
                } catch (e: ExpiredTokenException) {
                    onErrorCallback(e.message)
                    e.printStackTrace()
                    quickAuthClient.singout({}, onErrorCallback)
                    quickAuthClient.sign({}, onErrorCallback)
                } catch (e: Exception) {
                    e.printStackTrace()
                    onErrorCallback(e.message)
                } finally {
                    onLogsLoadingChange(false)
                }
            }
        }
    }
}